<app-breadcrumb
  [title]="'Enviar Notificaciones'"
  [items]="['Notificaciones']"
  [active_item]="'Enviar Notificaciones'"
>
</app-breadcrumb>
<div class="container-fluid">
<div class="card">
    <div class="card-header d-flex align-items-center bg-primary text-white">
      <i class="icofont icofont-brand-whatsapp me-2"></i>
      <h5 class="mb-0"><strong>Enviar notificaciones</strong></h5>
    </div>
  
    <div class="card-body">
      <form ngNativeValidate>
        <div class="row g-3">
            <div class="col-md-3">
                <label class="form-label" for="validationCustom01">
                  <strong>Tipo de Notificación *:</strong></label
                >
                <ng-select
  class="js-example-placeholder-multiple"
  [(ngModel)]="tipoSeleccionado"
  [items]="Notificaciones"
  bindLabel="label"
  bindValue="value"
  placeholder="Selecciona notificación">
</ng-select>

                <div class="valid-feedback">Looks good!</div>
              </div>
  
        </div>

          
      </form>
      <div class="d-flex gap-3 mt-3">
  <button 
    class="btn btn-primary d-flex align-items-center"
    type="button"
    (click)="sendNotificaciones()"
    [disabled]="cargando">

    <app-feather-icons [icon]="'send'" class="me-2"></app-feather-icons>
    <span class="text-center">
      {{ cargando ? 'ENVIANDO...' : 'ENVIAR NOTIFICACIONES' }}
    </span>
  </button>
</div>
      
      
    </div>
  </div>